module.exports = __webpack_public_path__ + "/hashedassets-launcher/illustration.57b331abdb1857e693705d3d91a7b20e.svg";